import React from 'react';
import { useSelector } from 'react-redux';
import { Price } from 'components/Common';
import getCategoryId from 'store/category/selector/getCategoryId';
import getFrameUpsellSelectedFrame from 'store/product/selector/getFrameUpsellSelectedFrame';
import { useTranslation } from 'react-i18next';
import styles from './FramePrice.module.scss';

const FrameDescription = () => {
  const selectedFrame = useSelector(getFrameUpsellSelectedFrame);
  const categoryId = useSelector(getCategoryId);
  const { t } = useTranslation();

  return (
    <div className={styles.framePrice}>
      {selectedFrame && selectedFrame.productId > 0 && (
        <>
          <Price
            prefix="+"
            categoryId={Number(selectedFrame.categoryId || categoryId)}
            productId={selectedFrame.productId}
          />
          <b className={styles.vat}>{t('txt_incl_vat')}</b>
        </>
      )}
    </div>
  );
};

export default FrameDescription;
